module.exports = __webpack_public_path__ + "img/jpm_moon-icon.c31b8662.png";